import { useEffect, useState } from "react";
import { Point } from "@evergis/sgis/es/Point";
import { useMapContext } from "@evergis/react";

export const useNavigatorGeolocation = () => {
  const [positions, setPositions] = useState<[number, number]>();
  const { map } = useMapContext();
  const fromMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent,
    );

  useEffect(() => {
    if (fromMobileDevice && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos: GeolocationPosition) => {
        const { latitude, longitude } = pos.coords;
        const { x, y } = new Point([latitude, longitude]).projectTo(map.crs);

        setPositions([x, y]);
      });
    }
  }, [navigator.geolocation, fromMobileDevice]);

  return positions;
};
